import React from "react";
import { TableRow, Checkbox, TableCell, makeStyles } from "@material-ui/core";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { amountFormat } from "../../../util/constants";
import moment from "moment";

const useStyles = makeStyles({
  customTable: {
    "& .MuiTableCell-alignLeft": {
      padding: "0px 0px 0px 0px",
    },
  },
});

export const InvoiceRow = ({
  selectionKey,
  isItemSelected,
  handleClick,
  row,
  columns,
  openActionMenu,
  actionButtonClass,
  labelId,
}) => {
  const classes = useStyles();
  return (
    <TableRow
      hover
      style={{ padding: "3px 0px", borderBottom: '1px solid lightgray' }}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.name}
      classes={{ root: classes.customTable }}
      selected={isItemSelected}
    >
      <TableCell padding="checkbox">
        <Checkbox
          onClick={(event) => handleClick(event, row[selectionKey])}
          checked={isItemSelected}
          inputProps={{ "aria-labelledby": labelId }}
        />
      </TableCell>

      <TableCell align="left"style={{fontWeight:500}}>{row["studentId"]}</TableCell>
      <TableCell align="left" style={{ textTransform: "capitalize ", fontWeight:500 }}>
        {row.student
          ? `${row.student.firstName} ${row.student.lastName}`
          : "Student Name"}
      </TableCell>

      <TableCell align="left"style={{fontWeight:500}}>{amountFormat(row["amount"] + row["otherFee"])}</TableCell>
      <TableCell align="left" style={{ fontWeight:500 }}>
        {moment(row["dueDate"]).format("DD/MM/YYYY")}
      </TableCell>

      <TableCell align="left">
        <div
          role="presentation"
          onClick={(e) => {
            openActionMenu(e, row);
          }}
          className={actionButtonClass}
        >
          <MoreHorizIcon />
        </div>
      </TableCell>
    </TableRow>
  );
};
